module.exports = __webpack_public_path__ + "static/media/receta-19.f0e92bf0.png";